/* eslint-disable radix */
import classNames from 'classnames';
import React, { memo, useEffect, useRef, useState } from 'react';
import { VariableSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import styles from './GridInfinteScroll.module.less';
// import { useActivate, useUnactivate } from 'react-activation';
import { scrollingDom } from '../../utils/utils';
import ResizeObserver from 'resize-observer-polyfill';
// import Column from 'antd/lib/table/Column';
import { setIsSearchClick } from '../../actions/search'; // 为热搜框弹窗消失不正确准备
import { useDispatch } from 'react-redux';

function GridInfinteScroll(props) {
  const {
    dataSource, // 数据集
    minimumBatchSize = 3, // 一行最多统一时间加载个数 默认10
    threshold = 3, // 预加载个数
    getItemSize, // 虚拟列表加载个数
    loadData, // 异步加载更多
    count = 0,
    columnWidth,
    template,
    tpl,
    gap = 25,
  } = props;
  const [data, SetData] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [node, setNode] = useState(null);
  const [el, setEl] = useState(null);
  const [nodeStyle, setNodestyle] = useState({ width: 0, height: 600 });
  const [column, setColumn] = useState(1);
  const [cWidth, setCWidth] = useState(0);

  const listRef = useRef(null);
  const dispatch = useDispatch();

  const handleScroll = () => {
    if (el && el.scrollTop > 1500) {
      setScroll(true);
    } else if (el) {
      setScroll(false);
    }
  };

  const handleScrollToTop = () => {
    let speed = 80;
    if (el && el.scrollTop > 0) {
      if (el.scrollTop > 1000) {
        speed = parseInt(el.scrollTop / 1000) * 50;
      }
      scrollingDom(el, 0, speed);
    }
  };

  const handleSize = () => {
    if (node) {
      const ro = new ResizeObserver(entries => {
        // eslint-disable-next-line no-restricted-syntax
        for (const entry of entries) {
          const { width, height } = entry.contentRect;
          const compCss = {
            height: parseInt(height),
            width: parseInt(width),
          };
          setNodestyle(compCss);
          // 根据元素宽度计算卡片宽度
          const tempWidth = width > 1660 ? 1660 : width;
          // eslint-disable-next-line no-restricted-globals
          if (columnWidth && !isNaN(columnWidth) && !isNaN(gap) && columnWidth < tempWidth) {
            const columnNumbers = parseInt((tempWidth - 30) / (+columnWidth + +gap));

            const tcwidth = (tempWidth - 30) / columnNumbers;
            setCWidth(tcwidth - gap);
            setColumn(columnNumbers);
          }
        }
      });

      ro.observe(node);
    }
  };
  useEffect(() => {
    if (node) {
      setEl(node.querySelector('div'));
      // 计算该元素的宽高
      handleSize();
    }
  }, [node]);

  useEffect(() => {
    if (el) {
      el.addEventListener('scroll', handleScroll);
    }
  }, [el]);
  useEffect(() => {
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
      }
    };
  }, [el]);

  useEffect(() => {
    if (listRef.current) {
      data.forEach((_, i) => listRef.current.resetAfterIndex(i));
    }

    SetData(() => {
      const list = dataSource.reduce((result, item, index) => {
        // eslint-disable-next-line radix
        const key = parseInt(index / column);
        if (result && result[key]) {
          result[key].push(item);
        } else {
          // eslint-disable-next-line no-param-reassign
          result[key] = [item];
        }
        return result;
      }, []);
      if (dataSource.length < count) {
        list.push(null);
      }

      return list;
    });
  }, [dataSource, column]);

  const loadMoreItems = (startIndex, stopIndex) => {
    loadData(startIndex, stopIndex);
  };

  const Row = ({ index, style }) => {
    return (
      <div style={style}>
        <div className={styles.tpl}>{index === 0 && tpl && tpl()}</div>
        <div
          className={styles.rowInfinte}
          style={
            columnWidth
              ? {
                  display: 'grid',
                  gridTemplateColumns: `repeat(auto-fill,minmax(${cWidth}px,1fr))`,
                  gridColumnGap: `${gap}px`,
                }
              : {}
          }
        >
          {data &&
            data[index] &&
            data[index].map((item, key) => (
              <div
                key={`${index}_${key}`}
                className={classNames(styles.rowInfinteItem)}
                style={{
                  width: '100%',
                  // marginLeft: cWidth && key % column !== 0 ? `${gap}px` : `${0}px`,
                }}
              >
                {template(item, key)}
              </div>
            ))}
        </div>
        {index === data.length - 1 && dataSource.length < count && (
          <div className={styles.loader}>----------加载中----------</div>
        )}
        {index === data.length - 1 && dataSource.length >= count && dataSource.length > 12 && (
          <div className={styles.loader}>----------到底啦----------</div>
        )}
      </div>
    );
  };

  if (!data || data.length < 1 || nodeStyle.width < 0) {
    if (tpl) {
      return (
        <div className={styles.InfiniteScroll}>
          <div className={styles.tpl}>{tpl()}</div>;
        </div>
      );
    }
    return null;
  }
  return (
    <div
      className={styles.InfiniteScroll}
      ref={r => setNode(r)}
      onClickCapture={() => {
        dispatch(setIsSearchClick(false));
      }}
    >
      <InfiniteLoader
        isItemLoaded={index => {
          return !!data[index];
        }}
        itemCount={data && data.length}
        loadMoreItems={loadMoreItems}
        minimumBatchSize={minimumBatchSize}
        threshold={threshold}
      >
        {({ onItemsRendered, ref }) => (
          <List
            width={nodeStyle.width}
            height={nodeStyle.height}
            itemSize={getItemSize}
            itemCount={data.length}
            onItemsRendered={onItemsRendered}
            ref={list => {
              ref(list);
              listRef.current = list;
            }}
            useIsScrolling
          >
            {Row}
          </List>
        )}
      </InfiniteLoader>
      {scroll && <div className={styles.scroll_top} onClick={handleScrollToTop} />}
    </div>
  );
}

export default memo(GridInfinteScroll);
